import { useState } from 'react';

import { useCurrentInstance } from '@/api/organization';
import ChevronDown from '@/assets/svg/chevron-down.svg?react';
import { Button } from '@/components/buttons';
import { GlobalLoader } from '@/components/GlobalLoader';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/Popover';
import { ROUTES } from '@/router';

import InstanceSwitcherContent from './InstanceSwitcherContent';

const InstanceSwitcher = () => {
  const { instance } = useCurrentInstance();
  const [open, setOpen] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);

  const handleSelectInstance = async (instanceId: string) => {
    setOpen(false);
    setIsSwitching(true);

    // Change url to the new instance. This will trigger a session exchange.
    window.location.href = ROUTES.appByInstanceId(instanceId);
  };

  if (isSwitching) {
    return <GlobalLoader />;
  }

  return (
    <Popover open={open} onOpenChange={setOpen} modal={false}>
      <PopoverTrigger
        render={
          <Button
            shape="square"
            className="pr-1 text-sm before:bg-transparent after:border-gray-400 [&_svg]:size-5"
          >
            <div className="flex items-center gap-1">
              {instance?.name}
              <ChevronDown />
            </div>
          </Button>
        }
      />
      <PopoverContent side="bottom" align="end" className="w-auto gap-0 p-0 shadow-2xl">
        <InstanceSwitcherContent
          onInstanceChange={handleSelectInstance}
          onClose={() => setOpen(false)}
        />
      </PopoverContent>
    </Popover>
  );
};

export default InstanceSwitcher;
